import React, { Component, Fragment } from "react";
import {
  extractImageValue,
  extractRangeValue,
} from "../../store/form.answer.extract";
import { Slider, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import { currentSectionState, openSectionState } from "../../store/form.store";
import { rangeAnswer } from "../../store/form.answer.fill";
import { ImageComponent } from "../../../components/ImageComponent";

const styles = (theme) => ({
  root: {
    padding: theme.spacing(1),
    marginTop: 0,
    width: "fit-content",
  },
  labelContainer: {
    flexDirection: "row",
    width: "100%",
  },
  minLabel: {
    marginLeft: "-2%",
    marginTop: "-7%",
    float: "left",
  },
  maxLabel: {
    float: "right",
    marginRight: "-2%",
    marginTop: "-7%",
  },
});

export class RangeSlider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 1,
      // helpTextValue: "",
      imageOpen: false,
      imageValue: [],
      imageUrl: "",
      imageName: "",
      editable: false,
    };
  }

  componentDidMount() {
    let expanded = "";
    this.sectionStateSubscription = openSectionState.subscribe((sectionId) => {
      expanded = sectionId;
    });
    this.currentSectionSubscription = currentSectionState.subscribe(
      (section) => {
        this.setState({ editable: section === expanded });
      }
    );
    this.onLoadPage(this.props);
    // if (this.props.element.properties.answerLabel) {
    //   this.onLoadHelpText(this.props);
    // }
    if (this.props.element.properties.allowFileUpload) {
      this.onLoadImage(this.props);
    }
  }

  onLoadPage(props) {
    if (props.element) {
      let answer = props.element.answer;
      let userResponse = extractRangeValue(answer);
      const minRange = Number.parseInt(props.element.properties.minRange, 10);
      const defaultMin = !isNaN(minRange) ? minRange : 0;

      if (
        userResponse !== undefined &&
        userResponse !== null &&
        !isNaN(userResponse)
      ) {
        this.setState({
          value: userResponse,
        });
      } else {
        this.setState({
          value: defaultMin,
        });
      }
    }
  }

  // onLoadHelpText(props) {
  //   const answerLabel = props.element.properties.answerLabel;
  //   if (answerLabel) {
  //     this.setState({ helpTextValue: answerLabel });
  //   }
  // }

  onLoadImage(props) {
    if (props.element) {
      let image = props.element.answer;
      let imageResponse = extractImageValue(image);
      if (imageResponse) {
        this.setState({
          imageValue: imageResponse,
        });
      }
    }
  }

  onChange = (event, value) => {
    this.setState({ value: value });
    let answerNode = rangeAnswer(value, this.props?.element?.answer);
    if (this.props.onChange !== undefined) {
      this.props.onChange(answerNode, this.props.element);
    }
  };

  render() {
    const { classes } = this.props;
    const properties = this.props.element?.properties || {};
    const minRange = Number.parseInt(properties.minRange, 10);
    const maxRange = Number.parseInt(properties.maxRange, 10);
    const step = Number.parseInt(properties.rangeMultiplier, 10);
    const currentValue = Number.parseInt(this.state.value, 10);

    // Set sensible defaults if parsing fails
    const safeMinRange = !isNaN(minRange) ? minRange : 0;
    const safeMaxRange = !isNaN(maxRange) ? maxRange : 100;
    const safeStep = !isNaN(step) && step > 0 ? step : 1;
    const safeValue = !isNaN(currentValue) ? currentValue : safeMinRange;

    const hasValidRange = safeMaxRange > safeMinRange;
    const markCount = (safeMaxRange - safeMinRange) / safeStep;
    const isValidConfig = hasValidRange && markCount > 0 && markCount <= 1000;

    return (
      <Fragment>
        {this.state.editable ? (
          isValidConfig ? (
            <Fragment>
              <Slider
                value={safeValue}
                onChange={(event, value) => this.onChange(event, value)}
                valueLabelDisplay="auto"
                step={safeStep}
                marks
                min={safeMinRange}
                max={safeMaxRange}
              />
              <span className={classes.labelContainer}>
                <Typography className={classes.minLabel}>
                  {safeMinRange}
                </Typography>
                <Typography className={classes.maxLabel}>
                  {safeMaxRange}
                </Typography>
              </span>
            </Fragment>
          ) : (
            <Typography color="error">
              Slider configuration is missing. Please set min, max, and step
              values.
            </Typography>
          )
        ) : (
          <Typography>{safeValue}</Typography>
        )}
        {/* {this?.state?.helpTextValue && (
          <FormHelperText>{this.state.helpTextValue}</FormHelperText>
        )} */}
        {this.props.element.properties.allowFileUpload &&
        this.state.imageValue.length > 0 ? (
          <ImageComponent imageList={this.state.imageValue} />
        ) : null}
      </Fragment>
    );
  }
}

export default withStyles(styles)(RangeSlider);
